import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "constants/query-keys";
import { ApiManager } from "services/api";
import { IHasTicketsResponse } from "services/api/integrations/integrations-api";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const fetchHasTicketsToImport = async () => {
  const { result, error } = await ApiManager.integrationsApi.fetchHasTicketsToImport();
  if (error) {
    throw error;
  }
  return result as IHasTicketsResponse;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useTicketsToImport = (onSuccess?: (data: IHasTicketsResponse) => void) => {
  const { data: ticketsToImport, isLoading } = useQuery<IHasTicketsResponse>({
    queryKey: [QueryKeys.HasTicketsToImport],
    queryFn: fetchHasTicketsToImport,
    onSuccess,
  });

  return {
    ticketsToImport,
    isLoading,
  };
};
